export default __webpack_public_path__ + "static/card-6-9cbc0d7d164a24d37e4991b7446843e2.svg";